import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=fabdee1e&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=fabdee1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabdee1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Verification: require('/var/jenkins_home/workspace/prod-web-xfans/components/verificationCode/verification.vue').default})
